import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';

import { QuotaItem, QuotaFilter } from '../../_models/quota-item';
import { QuotaService } from '../../_services/quota.service';

import { NotificationsService } from '../../_services/notifications.service';
import { Profile } from '../../_models/profile';

import { GestcuotaService } from '../../_services/gestcuota.service';

@Component({
  selector: 'app-quota-list',
  templateUrl: './quota-list.component.html',
  styleUrls: ['./_quota-list.component.scss'],
})
export class QuotaListComponent extends List implements OnInit {
  public static currentYear = new Date().getFullYear();
  public profile: Profile;
  errorMessage: string;
  filter: QuotaFilter;

  constructor(
    private quotaService: QuotaService,
    private gestcuotasService: GestcuotaService,
    private router: Router,
    private route: ActivatedRoute,
    protected notificationsService: NotificationsService
  ) {
    super(quotaService, new QuotaItem(), router, route);
  }

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    if (!this.profile.isShipOwner()) {
      this.router.navigate(['/quotas-aggregated']);
    }

    this.filter = new QuotaFilter();
    const currentYear = QuotaListComponent.currentYear;
    this.defaultFilterParams = `year=${currentYear}&campaign_year=${currentYear}`;
    const defaultFilterParams = this.defaultFilterParams;
    this.pageSize = 10000;
    this.initList('quotas', this.filter).then((result) => {
      if (this.profile.haveAccess('gestcuotas')) {
        this.getGestcuotas(this.collection, defaultFilterParams);
      }
    });
    this.defaultFilterParams = '';
    this.params['year'] = QuotaListComponent.currentYear;
  }

  getGestcuotas(collection, params) {
    this.gestcuotasService.list(1, 10000, params, '').subscribe(
      (response) => {
        for (const gestcuota of response.results) {
          const matchingQuota = collection.find(
            (quota) =>
              quota.ships &&
              quota.ships.length > 0 &&
              Number(quota.year) === Number(gestcuota.ship.id) &&
              Number(quota.stock.id) === Number(gestcuota.stock.id) &&
              Number(quota.year) === Number(gestcuota.campaign_year)
          );

          if (matchingQuota) {
            matchingQuota.gestcuota_adapted_amount = gestcuota.monthData[0].adapted_amount;
            matchingQuota.gestcuota_consumed = gestcuota.monthData[0].consumed;
            matchingQuota.gestcuota_amount_available = gestcuota.monthData[0].amount_available;
          } else {
            const gestcuota_formatted = {
              ships: [gestcuota.ship],
              stock: gestcuota.stock,
              year: gestcuota.campaign_year,
              gestcuota_adapted_amount: gestcuota.monthData[0].adapted_amount,
              gestcuota_consumed: gestcuota.monthData[0].consumed,
              gestcuota_amount_available: gestcuota.monthData[0].amount_available,
              not_quota: true,
            };
            gestcuota_formatted.stock['full_name'] = `${gestcuota.stock.name} ${gestcuota.stock.pseudonym}`;

            const stockExists = collection.some(
              (item) => item.not_quota && item.stock.id === gestcuota.stock.id && item.year === gestcuota.campaign_year
            );

            if (!stockExists) {
              collection.push(gestcuota_formatted);
            }
          }
        }

        this.collection.sort(this.orderQuotasByYear).reverse();
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  public applyFilter(params) {
    if (!Array.isArray(params.stock)) {
      params.stock = [params.stock];
    }

    const stockIds = params.stock ? (Array.isArray(params.stock) ? params.stock.map((s) => s.id || s) : [params.stock.id || params.stock]) : [];

    const params_string = {
      ships: params.ships ? (Array.isArray(params.ships) ? params.ships.map((s) => s.id || s) : [params.ships.id || params.ship]) : [],
      year: params.year,
      stock: stockIds,
    };

    const gestcuotaParams = {
      ship: params_string.ships,
      campaign_year: params_string.year,
      stock: stockIds,
    };

    const serialize_params = this.filter.serializeQueryParams(params_string);
    const serialize_params_gestcuota = this.filter.serializeQueryParams(gestcuotaParams);

    /* if (String(params.year) !== '') {
      serialize_params_gestcuota += '&campaign_year=' + String(params.year);
    } */

    this.collection = [];

    this.quotaService.list(1, 10000, serialize_params, '').subscribe(
      (response) => {
        const newCollection = [];
        for (const quota of response.results) {
          quota.stock['full_name'] = `${quota.stock.name} ${quota.stock.pseudonym}`;
          newCollection.push(quota);
        }
        this.collection = [...newCollection];

        if (this.profile.haveAccess('gestcuotas')) {
          this.getGestcuotas(this.collection, serialize_params_gestcuota);
        }
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  applyOrdering(param) {
    switch (param) {
      case 'ship':
        this.collection.sort(this.orderQuotasByShip);
        break;
      case '-ship':
        this.collection.sort(this.orderQuotasByShip).reverse();
        break;
      case 'stock':
        this.collection.sort(this.orderQuotasByStock);
        break;
      case '-stock':
        this.collection.sort(this.orderQuotasByStock).reverse();
        break;
      case 'year':
        this.collection.sort(this.orderQuotasByYear);
        break;
      case '-year':
        this.collection.sort(this.orderQuotasByYear).reverse();
        break;
      default:
        break;
    }
  }

  orderQuotasByShip(x, y) {
    return String(x.ships[0].name).localeCompare(String(y.ships[0].name));
  }

  orderQuotasByStock(x, y) {
    return String(x.stock.full_name).localeCompare(String(y.stock.full_name));
  }

  orderQuotasByYear(x, y) {
    return String(x.year).localeCompare(String(y.year));
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-list/quota-list.component.ts